export const HelpTerms = [
  {
    title: 'i18n.payments.arStatements.helpModal.invoice.term',
    definition: 'i18n.payments.arStatements.helpModal.invoice.definition',
    dataCy: 'credit-hold',
  },
  {
    title: 'i18n.payments.arStatements.helpModal.creditMemo.term',
    definition: 'i18n.payments.arStatements.helpModal.creditMemo.definition',
    dataCy: 'past-terms',
  },
  {
    title: 'i18n.payments.arStatements.helpModal.paymentDiscrepancy.term',
    definition:
      'i18n.payments.arStatements.helpModal.paymentDiscrepancy.definition',
    dataCy: 'close-to-terms',
  },
  {
    title: 'i18n.payments.arStatements.helpModal.debitMemo.term',
    definition: 'i18n.payments.arStatements.helpModal.debitMemo.definition',
    dataCy: 'current-percentage',
  },
  {
    title: 'i18n.payments.arStatements.helpModal.iatOther.term',
    definition: 'i18n.payments.arStatements.helpModal.iatOther.definition',
    dataCy: 'overdue-invoices',
  },
  {
    title: 'i18n.payments.arStatements.helpModal.coaOther.term',
    definition: 'i18n.payments.arStatements.helpModal.coaOther.definition',
    dataCy: 'scheduled-payments',
  },
  {
    title: 'i18n.payments.arStatements.helpModal.serviceCharge.term',
    definition: 'i18n.payments.arStatements.helpModal.serviceCharge.definition',
    dataCy: 'unused-credits',
  },
];
